// Función para limpiar completamente el caché del navegador
export function clearAllWalletCache() {
  // Limpiar todos los items relacionados con wallets
  const keysToRemove = [
    'userWallets',
    'userWallets-timestamp',
    'dashboardData',
    'dashboardData-timestamp',
    'dashboardDataTimestamp'
  ];

  // Limpiar items específicos de wallets crypto
  Object.keys(localStorage).forEach(key => {
    if (
      key.includes('wallet') ||
      key.includes('btc-') ||
      key.includes('eth-') ||
      key.includes('bnb-') ||
      key.includes('tron-') ||
      key.includes('sol-') ||
      key.includes('usdt-') ||
      key.includes('usdc-') ||
      key.includes('last-') ||
      key.includes('-timestamp')
    ) {
      localStorage.removeItem(key);
      console.log(`🗑️ Removed from cache: ${key}`);
    }
  });

  // Limpiar items específicos
  keysToRemove.forEach(key => {
    if (localStorage.getItem(key)) {
      localStorage.removeItem(key);
      console.log(`🗑️ Removed: ${key}`);
    }
  });

  console.log('✅ Wallet cache completely cleared');
}